import React from 'react';

function About() {
    console.log('hello')
    return (
        <section className='about'>
            <p className='about-text'><b>Hi! I'm Amelia, a junior developer based in Toronto.</b><br /><br />A former carpenter, <em>Lockdown 2020™</em> brought with it a desire for change. So I decided to learn to build apps instead of homes! I graduated from the UofT Coding Boot Camp in 2021.<br /><br />In my spare time, I can usually be found painting, snobbishly grinding my own coffee, or trying to solve the Wordle.</p>
        </section>
    );
};

export default About;